module.exports = __webpack_public_path__ + "static/media/shared_barcode.e10cafdb.png";